import { cloudAssetsDetailsRoute, onPremAssetsDetailsRoute } from "../../../AssetsRoutes";

export const getConformingAssetDetailsHref = (assetId: string, isCloud: boolean, contentType: string): string => {
    return isCloud ? getCloudAssetRoute(assetId, contentType) : getOnPremAssetRoute(assetId, contentType);
};

const getCloudAssetRoute = (assetId: string, contentType: string): string => {
    return `${cloudAssetsDetailsRoute.path.replace(":assetType", contentType).replace(":assetId", assetId)}`;
};

const getOnPremAssetRoute = (assetId: string, contentType: string): string => {
    return `${onPremAssetsDetailsRoute.path.replace(":assetType", contentType).replace(":assetId", assetId)}`;
};
